/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:49:54
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:04:49
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { hToggleArrayItem } from '@/utils/helpers';

import {
  TOGGLE_OFFLINE_STATUS, FILL_BANNERS_LIST, TOGGLE_MOBILE_MENU,
  TOGGLE_PENDING_STORE_ACTIONS, FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY, FILL_PANEL_FOOTER_ICONS,
  FILL_RODO_TERMS, FILL_OCCASION_ZONE_TILES_CONTENTS, FILL_OCCASION_ZONE_FORM_SETTINGS,
} from './mutation-types';

export default {
  [TOGGLE_PENDING_STORE_ACTIONS](state, payload) {
    const _state = state;
    _state.pendingStoreActions = hToggleArrayItem(_state.pendingStoreActions, payload);
  },

  [TOGGLE_OFFLINE_STATUS](state) {
    const _state = state;
    _state.isOffline = navigator === undefined ? !state.isOffline : !navigator.onLine;
  },
  [FILL_BANNERS_LIST](state, payload) {
    const _state = state;
    _state.bannersList = payload.banners;
  },

  [TOGGLE_MOBILE_MENU](state) {
    const _state = state;
    _state.mobileMenuIsVisible = !_state.mobileMenuIsVisible;
  },

  [FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY](state, payload) {
    const _state = state;
    _state.mainComponentsVisibility = payload.components;
  },

  [FILL_PANEL_FOOTER_ICONS](state, payload) {
    const _state = state;
    _state.panelFooterIcons = payload.panelFooterIcons;
  },

  [FILL_RODO_TERMS](state, payload) {
    const _state = state;
    _state.rodoTerms = payload.rodoTerms;
  },

  [FILL_OCCASION_ZONE_TILES_CONTENTS](state, payload) {
    const _state = state;
    _state.occasionZoneTilesContents = payload.occasionZoneTilesContents;
  },

  [FILL_OCCASION_ZONE_FORM_SETTINGS](state, payload) {
    const _state = state;
    _state.occasionZoneFormSettings = payload.occasionZoneFormSettings;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/App/mutations.js